import {
  Rotationsplan_StandortgruppeByIdQuery,
  Rotationsplan_StandortgruppeByIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { STANDORTGRUPPE_BY_ID } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/graphql/queries';
import { Standortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/entities/standortgruppe';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { useMemo } from 'react';

export function useStandortgruppe(standortGruppenId: string): {
  standortGruppe?: Standortgruppe | undefined;
  error?: string | undefined;
} {
  const result = useSuspenseQuery<
    Rotationsplan_StandortgruppeByIdQuery,
    Rotationsplan_StandortgruppeByIdQueryVariables
  >(STANDORTGRUPPE_BY_ID, {
    variables: { standortGruppenId },
  });

  const standortGruppe = useMemo(() => {
    const standortGruppeData = result.data?.mitarbeiter_standortgruppeById;
    if (!standortGruppeData) return undefined;
    return new Standortgruppe({
      id: standortGruppeData.id,
      istRotationsplanAktiviert:
        standortGruppeData.rotationsplanEinstellungen
          ?.istRotationsplanAktiviert,
      standorte: standortGruppeData.standorte.map(
        (s) =>
          new Standort({
            id: s.id,
            name: s.name,
            storenummer: s.storenummer ?? undefined,
            land: s.land,
          }),
      ),
    });
  }, [result.data]);

  if (result.error) {
    Sentry.captureException(result.error);
    return { standortGruppe: undefined };
  }

  return { standortGruppe };
}
